<template>
  <section class="page-container">
    <ArticleLayout
            :page="index!"
            class="mb-12"
            content-class="tablet:max-w-1/2 mx-auto"
            header-class="text-center section-title text-secondary"
            img-aspect-ratio="aspect-16/9"
            picture-class="max-w-2xl mx-auto block"
    />
    <div class="flex flex-wrap justify-center gap-x-12 tablet:gap-x-16 desktop:gap-x-20">
      <MDC
              v-for="page in getAllButIndex(pages)"
              :key="page.path"
              :value="page.title" class="strong-xl text-grey strong-block strong-brand mb-6" tag="div" unwrap="p"/>
    </div>
  </section>
</template>
<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {getIndex, getAllButIndex} = usePage();
const {pages} = defineProps<{
    pages: Array<PageCollectionItemBase>;
}>();
const index: PageCollectionItemBase = getIndex(pages)!;
</script>